import { render } from "./SidebarShop.vue?vue&type=template&id=6e2e37d5&ts=true"
import script from "./SidebarShop.vue?vue&type=script&lang=ts"
export * from "./SidebarShop.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__